import React from 'react'

import Sidebar from 'components/App/DesktopView/Layout/Sidebar'
// TODO: Fix direct duck reference without creating circular dependancy
import { CONVERSATIONS_PAGE } from 'ducks/reports/conversations/pages'
import { AGENTS_PAGE } from 'ducks/reports/agents/pages'
import { HAPPINESS_PAGE } from 'ducks/reports/happiness/pages'
import { PRODUCTIVITY_PAGE } from 'ducks/reports/productivity/pages'
import { TEAMS_PAGE } from 'ducks/reports/teams/pages'

const ITEMS = {
  [CONVERSATIONS_PAGE]: 'Conversations',
  [PRODUCTIVITY_PAGE]: 'Productivity',
  [HAPPINESS_PAGE]: 'Happiness',
  [AGENTS_PAGE]: 'Agents',
  [TEAMS_PAGE]: 'Teams',
}

export default function ReportsSideBarMailboxItem({
  activeMailboxId,
  activePage,
  mailbox: { id, name },
  totalItemsCount,
  showHappiness,
}) {
  const allMailboxesActive = !id && !activeMailboxId
  const activeMailbox =
    activeMailboxId === id || allMailboxesActive || totalItemsCount === 1
  return (
    <Sidebar.Accordion padded={2} initiallyActive={activeMailbox} title={name}>
      {Object.keys(ITEMS).map(key => {
        if (key === HAPPINESS_PAGE && !showHappiness) return null
        return (
          <Sidebar.Item
            key={key}
            active={activeMailbox && activePage === key}
            to={{ type: key, payload: { query: { inbox_id: id } } }}
            padded={3}
          >
            {ITEMS[key]}
          </Sidebar.Item>
        )
      })}
    </Sidebar.Accordion>
  )
}
